import { createBrowserHistory } from 'history';

/**
 * The app's shared history instance, deliberately in a module with no other side effects: the OIDC
 * bootstrap needs it before the app renders, and importing it must not drag in App.js - whose
 * module scope starts analytics and Sentry - while a one-time `?code` credential may still be in
 * the URL.
 */
export const historyList = sessionStorage.getItem('historyList')
    ? JSON.parse(sessionStorage.getItem('historyList'))
    : [];

export const history = createBrowserHistory();

history.listen(item => {
    historyList.push(item.pathname);
    sessionStorage.setItem('historyList', JSON.stringify(historyList));
});

export function getHistory(steps) {
    const prevPage = historyList.slice(-steps)[0];

    if (prevPage === window.location.pathname) return '/';

    return prevPage;
}
